import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import Avatar from 'components/common/Avatar';
import Flex from 'components/common/Flex';
import IconButton from 'components/common/IconButton';
import { weUserImage2 } from 'data/weraise-data/donar-data';
import React from 'react';
import { Button, Card } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import { getSize } from 'helpers/utils';

const ProjectInProgressTicket = () => {
  const navigate = useNavigate();
  const attachments = [
    { id: '1', title: 'winter.jpg', type: 'image/jpeg', size: 121212 },
    { id: '2', title: 'winter.png', type: 'image/jpeg', size: 1212 },
    { id: '3', title: 'title.zip', type: 'application/zip', size: 21212 },
    { id: '4', title: 'doc.pdf', type: 'application/pdf', size: 121432121 },
    { id: '5', title: 'data.cvs', type: 'text/csv', size: 121212 },
    { id: '6', title: 'winter 1.png', type: 'image/jpeg', size: 1212 },
    { id: '7', title: 'title.zip', type: 'application/zip', size: 21212 },
    { id: '8', title: 'tutorial.mp4', type: 'video/mp4', size: 12122243121 }
  ];
  return (
    <Card>
      <Card.Header className="bg-100">
        <Flex alignItems={'center'}>
          <IconButton
            icon={'chevron-left'}
            variant="falcon-default"
            onClick={() => navigate(-1)}
          />
          <IconButton
            icon={'envelope'}
            className="p-0 mx-3 text-900"
            variant="link"
          />
          <p className="fs-0 mb-0">HY Orphanage | Foundation Construction</p>
        </Flex>
      </Card.Header>
      <Card.Body>
        <Flex
          justifyContent={'between'}
          className="flex-column flex-md-row align-items-start align-items-md-center"
        >
          <Flex alignItems={'center'}>
            <Avatar src={weUserImage2} size="2xl" />
            <div className="ms-2">
              <p className="mb-0">Emma Watson</p>
              <p className="mb-0 text-500">Project Manager</p>
            </div>
          </Flex>
          <p className="mb-0 text-800 mt-3 mt-md-0 w-100 w-md-auto text-end">
            01 March, 2020 | 8:40 AM <i>(1 Day ago)</i>
          </p>
        </Flex>
        <div style={{ maxWidth: '525px', marginTop: '20px' }}>
          <p className="fs-0 fw-semi-bold text-1100">
            Foundation construction started
          </p>
          <p className="fs-0 text-700">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis
            aliquet ligula vitae facilisis vulputate.
          </p>
          <p className="fs-0 text-700">
            Ut rutrum cursus lacinia. Praesent consectetur semper nunc, sit amet
            rutrum dui commodo a. Lorem ipsum dolor.
          </p>
          <p className="fs-0 text-700">
            Please refer back to : <Link to={'#'}>This link </Link>for Short
            video placeholder for use in website templates and live mockups.
          </p>
        </div>
        <hr />
        <div className="bg-100 p-4 pb-3">
          <div style={{ maxWidth: '240px' }}>
            <ul className="ps-0">
              {attachments?.map((file, index) => (
                <li
                  className={classNames(
                    'list-group bg-white text-600 fs--1 border p-2 px-3',
                    {
                      'mb-2': index !== attachments.length - 1
                    }
                  )}
                  key={file.id}
                >
                  <Flex alignItems={'center'}>
                    <FontAwesomeIcon
                      className="me-3"
                      icon={
                        (file.type === 'image/png' && 'image') ||
                        (file.type === 'image/jpeg' && 'image') ||
                        (file.type === 'text/csv' && 'file') ||
                        (file.type === 'application/pdf' && 'file-pdf') ||
                        (file.type === 'application/zip' && 'file-archive') ||
                        (file.type === 'video/mp4' && 'video') ||
                        'paperclip'
                      }
                    />
                    {file.title} ({getSize(file.size)})
                    <Button
                      variant="link"
                      className="ms-auto p-0 text-400"
                      onClick={() => {}}
                    >
                      <FontAwesomeIcon icon={'times'} />
                    </Button>
                  </Flex>
                </li>
              ))}
            </ul>
          </div>
          <hr />
          <Flex
            justifyContent={'between'}
            alignItems="center"
            className="flex-column flex-md-row"
          >
            <p className="fw-medium mb-3 mb-md-0">
              <FontAwesomeIcon icon={'link'} className="me-3" />
              {attachments?.length} file{attachments?.length > 1 ? 's' : ''}{' '}
              attached
            </p>
            <IconButton variant="falcon-default" icon={'file-download'}>
              Download All
            </IconButton>
          </Flex>
        </div>
      </Card.Body>
    </Card>
  );
};

export default ProjectInProgressTicket;
